import moment from "moment";
import { workDayDateAfter, workDayDateAt } from "@shyne/shared";
import { AppointmentsRepository } from "@/repositories/appointments.repository";
import { TeamMembersRepository } from "@/repositories/team-members.repository";
import { DailyWorkRepository } from "@/repositories/daily-work.repository";
import type { DailyWorkDayJoin } from "@/repositories/daily-work.repository";
import { appointment_status } from "@/models/appointment.model";

export type SubsDashboardTimeRange = "7d" | "30d" | "90d";

export interface SubsDashboardStats {
  totalIndividuals: number;
  newAppointments: number;
  completedAppointments: number;
  totalAppointments: number;
  dailyWorkDaysCount: number;
}

function getDaysFromTimeRange(timeRange: SubsDashboardTimeRange): number {
  return timeRange === "7d" ? 7 : timeRange === "30d" ? 30 : 90;
}

export const subsDashboardApi = {
  async getDashboardStats(timeRange: SubsDashboardTimeRange): Promise<SubsDashboardStats> {
    const days = getDaysFromTimeRange(timeRange);
    const startDate = moment().subtract(days, "days").startOf("day").toDate();
    const endDate = moment().endOf("day").toDate();
    const dateFrom = startDate.toISOString().split("T")[0];
    const dateTo = endDate.toISOString().split("T")[0];
    const today = workDayDateAt(new Date());

    const totalIndividuals = await TeamMembersRepository.countActive();

    const { total, byStatus } = await AppointmentsRepository.countsForSubs({ dateFrom, dateTo });

    // Daily work days count for today (daily_work_days table only)
    const dailyWorkDaysResult = await DailyWorkRepository.listDaysForSubs(1, 1, { startDate: today, endDate: today }, "work_date", "asc");

    return {
      totalIndividuals,
      totalAppointments: total,
      newAppointments: byStatus[appointment_status.pending],
      completedAppointments: byStatus[appointment_status.done] + byStatus[appointment_status.completed],
      dailyWorkDaysCount: dailyWorkDaysResult.count ?? 0,
    };
  },

  /** Daily work days for the given range (daily_work_days table only). Range is from today through today + (days - 1). Used by Active Daily Work section. */
  async getDailyWorkDaysForSubs(range: SubsDashboardTimeRange): Promise<{ data: DailyWorkDayJoin[]; count: number }> {
    const days = getDaysFromTimeRange(range);
    const startDate = workDayDateAfter(0);
    const endDate = workDayDateAfter(days - 1);
    const result = await DailyWorkRepository.listDaysForSubs(1, 100, { startDate, endDate }, "work_date", "asc");
    return { data: result.data, count: result.count ?? 0 };
  },
};



